<template>
    <b-modal
        :id="modalId"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="lg"
        title="Edit link"
        centered
        @hide="hideModal"
    >
        <div class="row">
            <div class="form-group col-12">
                <label for="text">Text</label>
                <input
                    id="text"
                    v-model="item.text"
                    type="text"
                    class="form-control"
                    :class="{
                        'is-invalid': $v.item.text.$error
                    }"
                    dir="auto"
                />
            </div>
            <div class="form-group col-12">
                <label for="redirect">Redirect</label>
                <input
                    id="redirect"
                    v-model="item.redirect"
                    type="text"
                    class="form-control"
                    :class="{
                        'is-invalid': $v.item.redirect.$error
                    }"
                    dir="auto"
                />
            </div>
            <div class="form-group col-12">
                <b-form-checkbox v-model="item.blank" switch>
                    Open in new tab
                </b-form-checkbox>
            </div>
        </div>
        <template #modal-footer>
            <div class="col-12 d-flex justify-content-between">
                <button
                    type="submit"
                    class="btn btn-danger waves-effect waves-light"
                    @click="hideModal"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="save"
                >
                    Save
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
    validations: {
        item: {
            text: { required },
            redirect: { required }
        }
    },

    props: {
        modalId: {
            type: String,
            required: false,
            default: 'edit-link-modal'
        },
        link: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            item: { ...this.link }
        };
    },

    watch: {
        link() {
            this.item = { ...this.link };
        }
    },

    methods: {
        hideModal() {
            this.$bvModal.hide(this.modalId);

            this.$v.$reset();
        },

        save() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.$emit('input', this.item);

            this.hideModal();
        }
    }
};
</script>
